import {
  TIME_AVAILABILITY_REQUEST, TIME_AVAILABILITY_SUCCESS, TIME_AVAILABILITY_FAILURE,
  TIME_DISPONIBILITY_REQUEST, TIME_DISPONIBILITY_SUCCESS, TIME_DISPONIBILITY_FAILURE,
  TIME_PREBOOKING_REQUEST, TIME_PREBOOKING_SUCCESS, TIME_PREBOOKING_FAILURE,
  TIME_RENT_REQUEST, TIME_RENT_SUCCESS, TIME_RENT_FAILURE,
  TIME_ACCESS_REQUEST, TIME_ACCESS_SUCCESS, TIME_ACCESS_FAILURE,
  TIME_OPEN_REQUEST, TIME_OPEN_SUCCESS, TIME_OPEN_FAILURE,
  TIME_OPEN_STATUS_REQUEST, TIME_OPEN_STATUS_SUCCESS, TIME_OPEN_STATUS_FAILURE,
  TIME_FINALIZE_REQUEST, TIME_FINALIZE_SUCCESS, TIME_FINALIZE_FAILURE,
  TIME_EXTEND_REQUEST, TIME_EXTEND_SUCCESS, TIME_EXTEND_FAILURE,
} from '../actions/qrstime'

const INITIAL_STATE = {
  availability: null,
  disponibility: null,
  prebooking: null,
  rental: null,
  access: null,
  openResult: null,
  openStatus: null,
  finalizeResult: null,
  extendResult: null,
  error: null,
  loading: false,
}

const qrstimeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TIME_AVAILABILITY_REQUEST:
      return { ...state, availability: null, error: null, loading: true }
    case TIME_AVAILABILITY_SUCCESS:
      return { ...state, availability: action.response, error: null, loading: false }
    case TIME_AVAILABILITY_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_DISPONIBILITY_REQUEST:
      return { ...state, disponibility: null, error: null, loading: true }
    case TIME_DISPONIBILITY_SUCCESS:
      return { ...state, disponibility: action.response, error: null, loading: false }
    case TIME_DISPONIBILITY_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_PREBOOKING_REQUEST:
      return { ...state, prebooking: null, error: null, loading: true }
    case TIME_PREBOOKING_SUCCESS:
      return { ...state, prebooking: action.response, error: null, loading: false }
    case TIME_PREBOOKING_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_RENT_REQUEST:
      return { ...state, rental: null, error: null, loading: true }
    case TIME_RENT_SUCCESS:
      return { ...state, rental: action.response, error: null, loading: false }
    case TIME_RENT_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_ACCESS_REQUEST:
      return { ...state, access: null, error: null, loading: true }
    case TIME_ACCESS_SUCCESS:
      return { ...state, access: action.response, error: null, loading: false }
    case TIME_ACCESS_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_OPEN_REQUEST:
      return { ...state, openResult: null, error: null, loading: true }
    case TIME_OPEN_SUCCESS:
      return { ...state, openResult: action.response, error: null, loading: false }
    case TIME_OPEN_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_OPEN_STATUS_REQUEST:
      return { ...state, loading: true }
    case TIME_OPEN_STATUS_SUCCESS:
      return { ...state, openStatus: action.response, error: null, loading: false }
    case TIME_OPEN_STATUS_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_FINALIZE_REQUEST:
      return { ...state, finalizeResult: null, error: null, loading: true }
    case TIME_FINALIZE_SUCCESS:
      return { ...state, finalizeResult: action.response, error: null, loading: false }
    case TIME_FINALIZE_FAILURE:
      return { ...state, error: action.error, loading: false }

    case TIME_EXTEND_REQUEST:
      return { ...state, extendResult: null, error: null, loading: true }
    case TIME_EXTEND_SUCCESS:
      return { ...state, extendResult: action.response, error: null, loading: false }
    case TIME_EXTEND_FAILURE:
      return { ...state, error: action.error, loading: false }

    default:
      return state
  }
}

export default qrstimeReducer
